<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="toc"><b>Contents</b></p>
<p class="toc1"><a href="#/ack"><i>Acknowledgements</i></a></p>
<p class="toc1p"><a href="#/itr"><i>Introduction</i></a></p>
<p class="toc1"><a href="#/chap1"><span class="small">1. THE EVOLUTION OF AN ARCHETYPE</span></a></p>
<p class="toc2"><a href="#/chap1#chap1_sub1">Kronos the Titan</a></p>
<p class="toc2"><a href="#/chap1#chap1_sub2">The Mythic Kronos and the Roman Saturn</a></p>
<p class="toc2"><a href="#/chap1#chap1_sub3">The Old Malefic</a></p>
<p class="toc2"><a href="#/chap1#chap1_sub4">The Midwife of Insight</a></p>
<p class="toc2"><a href="#/chap1#chap1_sub5">The Alchemical Lead</a></p>
<p class="toc2"><a href="#/chap1#chap1_sub6">The Master of Time</a></p>
<p class="toc1t"><a href="#/chap2"><span class="small">2. THE NATURAL CYCLES OF SATURN</span></a></p>
<p class="toc2"><a href="#/chap2#chap2_sub1">A Journey towards Individuation</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub2">Natal Saturn to Saturn Square (Birth-7)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub3">Saturn Square to Saturn Opposition (7-14)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub4">Saturn Opposition to Saturn Square (14-21)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub5">Saturn Square to Saturn Return (22-29)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub6">Saturn Return to Saturn Square (29-36)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub7">Saturn Square to Second Saturn Opposition (37-44)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub8">Second Saturn Opposition to Saturn Square (45-52)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub9">Saturn Square to Second Saturn Return (52-59)</a></p>
<p class="toc2"><a href="#/chap2#chap2_sub10">Second Saturn Return Onwards (from age 59)</a></p>
<p class="toc1t"><span href="#/chap3" title="Link target outside of Sample"><span class="small">3. THE HEROIC ROUND</span></span></p>
<p class="toc2"><span href="#/chap3#chap3_sub1" title="Link target outside of Sample">Heroism</span></p>
<p class="toc2"><span href="#/chap3#chap3_sub2" title="Link target outside of Sample">Hamartia: The Hero and the Tragic Flaw</span></p>
<p class="toc2"><span href="#/chap3#chap3_sub3" title="Link target outside of Sample">The Mythological Round</span></p>
<p class="toc2"><span href="#/chap3#chap3_sub4" title="Link target outside of Sample">The Angles</span></p>
<p class="toc1t"><span href="#/chap4" title="Link target outside of Sample"><span class="small">4. THE PERSONAL HEROIC JOURNEY</span></span></p>
<p class="toc2"><span href="#/chap4#chap4_sub1" title="Link target outside of Sample">Experiencing Boundaries, Definition and Containment</span></p>
<p class="toc2"><span href="#/chap4#chap4_sub2" title="Link target outside of Sample">Seeing the Inside on the Outside</span></p>
<p class="toc2"><span href="#/chap4#chap4_sub3" title="Link target outside of Sample">The Transit of Saturn over the Angles</span></p>
<p class="toc3"><span href="#/chap4#chap4_sub4" title="Link target outside of Sample"><i>The Call to Adventure (MC)</i></span></p>
<p class="toc3"><span href="#/chap4#chap4_sub5" title="Link target outside of Sample"><i>The Threshold Struggle (Asc.)</i></span></p>
<p class="toc3"><span href="#/chap4#chap4_sub6" title="Link target outside of Sample"><i>The Atonement (IC)</i></span></p>
<p class="toc3"><span href="#/chap4#chap4_sub7" title="Link target outside of Sample"><i>The Call to Return (Desc.)</i></span></p>
<p class="toc1t"><span href="#/chap5" title="Link target outside of Sample"><span class="small">5. THE TRANSIT OF SATURN TO THE PLANETS</span></span></p>
<p class="toc2"><span href="#/chap5#chap5_sub1" title="Link target outside of Sample">Aspects: The Eye of Saturn</span></p>
<p class="toc2"><span href="#/chap5#chap5_sub2" title="Link target outside of Sample">The Story of Job</span></p>
<p class="toc2"><span href="#/chap5#chap5_sub3" title="Link target outside of Sample">Saturn in Transit to Natal Planets</span></p>
<p class="toc1t"><span href="#/notes" title="Link target outside of Sample"><i>Notes</i></span></p>
<p class="toc1"><span href="#/bib" title="Link target outside of Sample"><i>Bibliography</i></span></p>
<p class="toc1"><span href="#/index" title="Link target outside of Sample"><i>Index</i></span></p>
<p class="toc1"><span href="#/author" title="Link target outside of Sample"><i>About the Author</i></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?8f6fe05a